import { useSelector } from 'react-redux';
import { selectPriceTypeFilter } from 'shared/selectors/filters';
import { DropdownFilter, DropdownSelect, useDropdown } from 'shared/components/DropdownFilter';
import { useFilterChangeCallback } from 'shared/hooks';
import { useCallback } from 'react';
import { EPriceType } from '../../../../../packages/JsonQuery';
import { FILTER_KEY } from '../../constants';
import { selectIsInlineFiltersRedesigned } from 'shared/selectors/redesigned/selectIsInlineFiltersRedesigned';

export const PriceTypeContainer = () => {
  const { label, value, options } = useSelector(selectPriceTypeFilter);

  const onChange = useFilterChangeCallback(FILTER_KEY);

  const { opened, onClose, onOpen } = useDropdown(FILTER_KEY);

  const handleChange = useCallback(
    (priceType: EPriceType) => {
      const isSquareMeterPrice = priceType === EPriceType.SM ? true : null;

      onClose();
      onChange({ action: 'setPriceType', arguments: [isSquareMeterPrice] });
    },
    [onChange, onClose],
  );

  const isFiltersRedesignEnabled = useSelector(selectIsInlineFiltersRedesigned);

  return (
    <DropdownFilter
      opened={opened}
      onClose={onClose}
      onOpen={onOpen}
      buttonLabel={label}
      isFiltersRedesignEnabled={isFiltersRedesignEnabled}
      buttonStyle="dashed"
      dropdownContent={<DropdownSelect options={options} value={value} onChange={handleChange} />}
    />
  );
};
